/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'catalog': {
    viewBox: '0 0 24 24',
    data: `<rect x="11" y="8.001" width="4" height="1"/><rect x="11" y="11.501" width="4" height="1"/><rect x="11" y="15.001" width="4" height="1"/><path d="M18,19H7V5H18ZM8.024,17.994h8.952V6.006H8.024Z"/><rect x="6" y="8.001" width="3" height="1"/><rect x="6" y="11.501" width="3" height="1"/><rect x="6" y="15.001" width="3" height="1"/>`
  }
})
